// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"43af3a78","769":"083c5d8e"}[chunkId] + ".chunk.js";
};